<template>
    <VeeForm :validation-schema="sizeValidationSchema" v-slot="{ handleSubmit, errors }" @invalid-submit="onInvalidSubmit" as="div" class="col-12 col-xxl-8 mt-2 mt-xxl-0">
        <form ref="form" @submit="handleSubmit($event, onSizeSubmit)" method="post" :action="this.baseUrl + '/enter-size-submit'" class="size-form">
            <div class="row gx-3 w-100 align-items-center">
                <div class="col-12 col-lg-6">
                    <div class="row gx-3">
                        <div class="col-6 col-md-3 mb-2 mb-md-0" v-for="(option, key) in formattedOptions" :key="key">
                            <ErrorMessage :name="option.name" v-slot="{ message }">
                                <span class="error"></span>
                            </ErrorMessage>
                            <Popper :content="errors[option.name]" arrow placement="top" class="w-100 m-0 border-0" :show="errors[option.name] ? true : false">
                                <Field :id="option.name" v-slot="{ value }" :name="option.name" as="select" class="form-select size-input" :title="errors[option.name]">
                                    <option value="" disabled>{{ option.label }}</option>
                                    <option v-for="item in option.data" :key="item" :value="item" :selected="value && value.includes(item)">{{ item }}</option>
                                </Field>
                            </Popper>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-4 mt-3 mt-lg-0">
                    <div class="row gx-3">
                        <div class="col-6 col-md-5">
                            <ErrorMessage name="size_postcode">
                                <span class="error"></span>
                            </ErrorMessage>
                            <Popper :content="errors.size_postcode" arrow placement="top" class="w-100 m-0 border-0" :show="errors.size_postcode ? true : false">
                                <Field id="size_postcode" name="size_postcode" type="text" class="form-control size-postcode" :value="postcode" placeholder="Postcode" />
                            </Popper>
                        </div>
                        <div class="col-6 col-md-7">
                            <Field v-if="brand" name="brand" type="hidden" :value="brand" />
                            <Field v-if="priceRange" name="price_range" type="hidden" :value="priceRange" />
                            <Field v-if="mobileFitting == true" type="hidden" name="mobile_fitting" :value="true"/>
                            <button class="btn btn-primary" type="submit">
                                <p class="mb-0 text-white">Search by Size</p>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col text-underline cursor-pointer mt-2 mt-xxl-0" @click="toggleForm">Or search by reg</div>
            </div>
        </form>
    </VeeForm>
</template>

<script>
    import { Form as VeeForm, Field , ErrorMessage } from 'vee-validate';
    import * as yup from 'yup';

    export default {
        props: [
            'options',
            'postcode',
            'brand',
            'priceRange',
            'mobileFitting'
        ],
        components: {
            VeeForm,
            Field,
            ErrorMessage
        },
        data() {
            const sizeValidationSchema = yup.object({
                'width': yup.string().required(),
                'profile': yup.string().required(),
                'rim': yup.string().required(),
                'size_postcode': yup.string().required('postcode is a required field').nullable()
            });

            return {
                sizeValidationSchema
            }
        },
        mounted() {
        },
        methods: {
            onSizeSubmit(values) {
                // take object values and format as array, to use join method on.
                var selected_size = Object.values(values);

                //remove any undefined/null entries from posted values
                const normalizedSizes = selected_size.filter(item => item);

                //formats data with pipes for submission
                var format_size = normalizedSizes.join('|');
                
                axios.post('/ajax/validate_size/' + format_size)
                .then(response => {
                    if(response.data.size_exists == false)
                    {
						// actions.setErrors({
					    //     'Width': 'this size doesn\'t exist',
					    //     'Profile': 'this size doesn\'t exist',
					    //     'Diameter (Rim Size)': 'this size doesn\'t exist',
					    // });
                    }
                    
                    this.$refs.form.submit();

                    return true;
                })
                .catch(error => {
                    console.error("There was an error!", error);
                });
            },
            toggleForm() {
                this.$emit('toggleForm', 'reg');
            },
            onInvalidSubmit({ values, errors, results }) {
                //Focus first invalid field
                var firstInvalidField = document.getElementsByName(Object.keys(errors)[0]);
                firstInvalidField[0].focus();
            },
        },
        computed: {
            formattedOptions: function() {
                return [
                    { label: 'Width', name: 'width', data: this.options.width },
                    { label: 'Profile', name: 'profile', data: this.options.profile },
                    { label: 'Rim', name: 'rim', data: this.options.rim },
                    { label: 'Speed', name: 'speed', data: this.options.speed },
                    // { label: 'Load', name: 'load', data: this.options.load_index },
                ]
            }
        }
    }
</script>
<style lang="scss" scoped>
    .error {
        color: red;
    }
    .size-form {
        .size-input {
            background-color: #fff;
            height: 40px;
            width: 100%;
            text-transform: capitalize;
            font-weight: 400;
            padding-left: 5px;
            font-size: 14px;
            border-radius: 3px;
        }
        .btn {
            width: 100%;
            font-size: 16px;
            p {
                font-weight: 400;
            }
        }
    }
    .size-postcode {
        padding: 8.5px 10px;
        font-size: 14px;
    }
</style>